import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';

export const companyBenefitGroupSettingsUrl = `${config.apiHost}/api/v2/company-benefit-groups/settings`;

export const companyBenefitGroupSettingsActiveBenefitsUrl = `${companyBenefitGroupSettingsUrl}/active/benefit-types`;

export const companyBenefitsGroupSetting = () =>
  `${companyBenefitGroupSettingsUrl}/benefit-types`;

export const fetchActiveBenefits = () =>
  get(companyBenefitGroupSettingsActiveBenefitsUrl);
